<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button class="btn" size="small" type="primary" @click="handleCreate">添加验收</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item :label="lable.deviceTypeName">
            <el-cascader v-model="questionForm.statue" style="width:100%" :options="options" :props="props" clearable
              filterable :show-all-levels="true"></el-cascader>
          </el-form-item>
          <el-form-item label="保管员">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入保管员"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="small" type="primary" @click="getPurchaseClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="tableData" tooltip-effect="dark"
          style="width: 100%;text-align: center" stripe>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" show-overflow-tooltip>
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="biu(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="deviceName" :label="lable.deviceName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="deviceTypeName" :label="lable.deviceTypeName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="producer" :label="lable.producer" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="deviceMany" :label="lable.deviceMany" show-overflow-tooltip>
          </el-table-column>

          <el-table-column prop="num" :label="lable.num" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '3'" style="color:yellowgreen">待验收</span>
              <span v-else style="color:yellowgreen">待验收</span>
            </template>
          </el-table-column>
          <el-table-column prop="sgdh" :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">更改</el-button>
              <el-button type="text" @click="deleteCheck(scope.row)" size="small">删除</el-button> -->
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
              <el-button @click="yulan(scope.row)" type="text" size="small">附件预览</el-button>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="tableData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>

    <!-- ------------------------------------------------------------- 添加验收---------------------------------------------------------------------------------------------- -->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="添加验收"
      style="width:60% !important;margin-left: 400px;">
      <el-form :model="inForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.purchaseNumber" prop="purchaseNumber">
          <el-select v-model="inForm.purchaseNumber" filterable clearable style="width: 100%" @change="findById"
            :placeholder="'请选择' + lable.purchaseNumber">
            <el-option v-for="item in idOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.deviceTypeName" prop="sblb">
          <el-cascader v-model="inForm.sblb" style="width:100%" :disabled="true" :options="options" :props="props"
            :show-all-levels="true" filterable></el-cascader>
        </el-form-item>
        <el-form-item :label="lable.deviceName" prop="sbmc">
          <el-input placeholder="请选择采购单号" :readonly="true" v-model="inForm.sbmc" />
        </el-form-item>
        <el-form-item :label="lable.sbbm" prop="sbbm">
          <el-input :placeholder="'请输入' + lable.sbbm" v-model="inForm.sbbm" />
        </el-form-item>
        <el-form-item label="保管员" prop="bgy">
          <el-input placeholder="请输入保管人" v-model="inForm.bgy" />
        </el-form-item>
        <el-form-item label="设备图片">
          <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
            accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
            :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
            <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
          </el-upload>
          <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload"
          v-preventReClick>上传</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!------------------------------------------------------------------------- 更改验收弹出框------------------------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" title="更改验收" style="width:60% !important;margin-left: 400px;"
    :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 80%; margin-left:30px;">
        <el-form-item :label="lable.purchaseNumber" prop="purchaseNumber">
          <el-select v-model="questionForm.purchaseNumber" filterable clearable style="width: 100%"
            :placeholder="'请选择' + lable.purchaseNumber">
            <el-option v-for="item in idOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.deviceTypeName" prop="sblb">
          <el-cascader v-model="questionForm.sblb" :disabled="true" style="width:100%" :options="options" :props="props"
            :show-all-levels="true" filterable></el-cascader>
        </el-form-item>
        <el-form-item :label="lable.deviceName" :readonly="true" prop="sbmc">
          <el-input v-model="questionForm.sbmc" />
        </el-form-item>
        <el-form-item :label="lable.sbbm" prop="sbbm">
          <el-input :placeholder="lable.sbbm" v-model="questionForm.sbbm" />
        </el-form-item>
        <el-form-item label="保管员" prop="bgy">
          <el-input placeholder="请输入保管员" v-model="questionForm.bgy" />

        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" v-preventReClick
          @click="updateCheck">更改</el-button>
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
      </div>
    </el-dialog>
    <!--------------------------------------------------------------------------------------采购计划详情弹出 ---------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible2" :close-on-click-modal="false"
      :close-on-press-escape="false" title="验收详情"
      style="width: 90% !important;margin-left:10%;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" prop="id" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceTypeName" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.deviceTypeName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.deviceName">
              <el-input :readonly="true" v-model="questionForm.deviceName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="量程" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.lc" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="精度等级">
              <el-input :readonly="true" v-model="questionForm.jddj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.num" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.num" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.producer">
              <el-input :readonly="true" v-model="questionForm.producer" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.deviceMany" style="width: 90%">
              <el-input :readonly="true" v-model="questionForm.deviceMany" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税额">
              <el-input :readonly="true" v-model="questionForm.amount" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="审批理由" prop="reject">
          <el-input :readonly="true" v-model="questionForm.reject" />
        </el-form-item>


      </el-form>
      <el-button type="primary" @click="dialogFormVisible2 = false">确认</el-button>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import {
  findAllPurchaseInformation,
  findByIdPurchaseInformation,
  addPurchaseCheck,
  updatePurchaseCheck,
  deletePurchaseCheck,
  findAllCheckId,
  findByModule,
  selectTreeDeviceType
} from "../../api/api";
import FilePreview from '../../components/preview/FilePreview.vue'

export default {
  name: "Check",
  components: {
    "FilePreview": FilePreview,
  },
  data() {
    return {
      deviceInfo: {
        statue: '',
        content: ''
      },
      lable: {},
      idOptions: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      tableData: [],
      inForm: [],
      //文件上传
      fileData: [],
      fileList: [],
      previewTitle: '',
      docxdialog: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      questionForm: {},
      options: [],
      props: {
        label: 'deviceTypeName',
        value: 'id',
        children: 'deviceTypes',
        expandTrigger: 'click',
        emitPath: false
      },
      innerVisible: false,
      form: {}
    };
  },
  methods: {
    biu(row) {
      this.inForm = {};
      this.$set(this.inForm, 'purchaseNumber', row.id)
      this.findById(row.id)
      this.dialogFormVisible = true;
    },
    cancel() {
      this.dialogFormVisible = false;
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
      this.getPurchase();
    },
    handleClick(row) {
      this.questionForm = {};
      this.questionForm = _.cloneDeep(row);
      this.dialogFormVisible1 = true;
    },
    yulan(row) {
      console.log(row)
      if (row.fjzl.substring(row.fjzl.lastIndexOf(".") + 1) == 'jpg' || row.fjzl.substring(row.fjzl.lastIndexOf(".") + 1) == 'png' || row.fjzl.substring(row.fjzl.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.fjzl)
      })
      // this.downloadUtil.preview(row.path)
    },
    findById(row) {
      var map = {
        id: row
      }
      findByIdPurchaseInformation(map).then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.$set(this.inForm, 'sblb', data[0].sblb)
          this.$set(this.inForm, "sbmc", data[0].deviceName)
        }
      });
    },
    deleteCheck(row) {
      this.$confirm('此操作将永久删除信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"))
        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        deletePurchaseCheck(map).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message.error(message)
          } else if (status == 200) {
            this.getPurchase();
            this.$message.success("删除成功")
            // debugger
          } else {
            this.$message.error("请求错误")
          }
        });
      })
    },
    updateCheck() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      updatePurchaseCheck(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message.error(message)
        } else if (status == 200) {
          this.dialogFormVisible1 = false;
          this.getPurchase();
          this.$message.success("修改成功")
          // debugger
        } else {
          this.$message.error("请求错误")
        }
      });
    },
    selectClick(row) {
      this.questionForm = {};
      this.questionForm = _.cloneDeep(row);
      this.dialogFormVisible2 = true;
    },
    handleCreate() {
      this.inForm = {};
      this.dialogFormVisible = true;
    },
    //采购添加上传
    submitUpload() {
      if (this.fileList[0] == null) {
        this.$message.warning("请选择验收的文件")
      } else {
        let formData = new FormData();
        var userinfo = JSON.parse(localStorage.getItem("user"))

        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("purchaseNumber", this.inForm.purchaseNumber == null ? "" : this.inForm.purchaseNumber);
        formData.append("sblb", this.inForm.sblb == null ? "" : this.inForm.sblb);
        formData.append("sbmc", this.inForm.sbmc == null ? "" : this.inForm.sbmc);
        formData.append("sbbm", this.inForm.sbbm == null ? "" : this.inForm.sbbm);
        formData.append("bgy", this.inForm.bgy == null ? "" : this.inForm.bgy);
        formData.append("userId", userinfo.userId);
        addPurchaseCheck(formData).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message.error(message)
          } else if (status == 200) {
            this.dialogFormVisible = false;
            this.getPurchase();
            this.$message.success("添加成功")
          } else {
            this.$message.error("请求错误")
          }
          this.fileList = [];
        });
      }
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },
    getPurchaseClick(){
      this.pageIndex=1
      this.getPurchase()
    },
    //查找验收信息
    getPurchase() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      let map = {
        start: null,
        end: null,
        status: 3,
        content: this.deviceInfo.content,
        userId: userinfo.userId
      };
      findAllPurchaseInformation(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.tableData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = data.length;
          console.log(data)
          // debugger
        }
      });
    },
    findAllType() {
      selectTreeDeviceType().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    findAllId() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      findAllCheckId(userinfo.userId).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.idOptions = data;
        }
      });
    },
    findLable() {
      findByModule("采购管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
    },
  },
  created() {
    this.findLable()
    this.findAllType();
    this.findAllId();
    this.getPurchase();
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style  scoped>
.btn {
  float: left;
  margin-left: 5px;
}

.el-input {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/Check.vue